// extracted by mini-css-extract-plugin
export var container = "iconSymbols-module--container--3d88a";